import { Grid, Typography } from "@mui/material";
import React, { useEffect } from "react";
import {
  Control,
  FieldErrors,
  UseFormRegister,
  UseFormReset,
} from "react-hook-form";
import WSSelectField from "../../Components/Select/WSSelect";
import WSTextField, { TextType } from "../../Components/TextBox/WSTextBox";
import WSTextAreaField from "../../Components/WSTextArea/WSTextArea";
import { callAPI, IRoleMain, IsSmallScreen, MasterPages, Method } from "../../commonFunctions/CommonFunctions";
import PermissionDenied from "../../commonFunctions/PermissionDenied";
import { getPermissions } from "../../commonFunctions/PermissionManger";
import WSRadioField from "../../Components/Radio/WSRadio";

interface SelectUnitProps {
  control: Control<any>;
  errors: FieldErrors;
  register: UseFormRegister<any>;
  id: any;
  reset: UseFormReset<any>;
  departmentId?: string;
  setValue: any;
}
const SelectUnit: React.FC<SelectUnitProps> = ({
  control, errors, register, id, reset, departmentId, setValue, }) => {
  const isMobile=IsSmallScreen()
  useEffect(
    () => () => {
      reset();
    },
    [id, reset]
  );

 
  return (
    <>
          <Grid  style={{paddingLeft:5,paddingRight:20,position:'relative',margin:0,marginTop:'3rem'}} container spacing={2}>
            <Grid item xs={12} sm={6}>
               <WSSelectField
                rules={{ required: true }}
                {...register("baseUnit")}
                id="baseUnit"
                control={control}
                isMobile={isMobile}
                label="Base Unit"
                name="baseUnit"
              />
            </Grid>
            <Grid item xs={12} sm={6}>
               <WSSelectField
                rules={{ required: true }}
                {...register("secondaryUnit")}
                id="secondaryUnit"
                control={control}
                isMobile={isMobile}
                label="Secondary Unit"
                name="secondaryUnit"
              />
            </Grid>
      
            <Grid item xs={12} >
             <Typography  variant="subtitle1" gutterBottom>Conversion Rates</Typography>
            </Grid>
            <Grid item xs={12}>
                  <WSRadioField
                    defaultValue={""}
                    control={control}
                    label=""
                    rules={{ required: false }}
                    id=""
                    name=""
                    options={[
                      {
                        label: "1 MILILITRE = 0 LITRE      ",
                        value: "1 ML       ",
                      },
                     
                    ]}
                  />
            </Grid>
             <Grid item xs={12}>
                  <WSRadioField
                    defaultValue={""}
                    control={control}
                    label=""
                    rules={{ required: false }}
                    id=""
                    name=""
                    options={[
                      {
                        label: "1 MILILITRE  = 0.001 LITRE      ",
                        value: "1 ML       ",
                      },
                     
                    ]}
                  />
            </Grid>
             <Grid item xs={12}>
                  <WSRadioField
                    defaultValue={""}
                    control={control}
                    label=""
                    rules={{ required: false }}
                    id=""
                    name=""
                    options={[
                      {
                        label: "1 MILILITRE   = 1 LITRE     ",
                        value: "1 ML       ",
                      },
                     
                    ]}
                  />
            </Grid>
          </Grid>
          </>

  );
};
export default SelectUnit;
